import { render, staticRenderFns } from "./ModalSuporteEditarCaixaCirurgica.vue?vue&type=template&id=04783e2e&scoped=true"
import script from "./ModalSuporteEditarCaixaCirurgica.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteEditarCaixaCirurgica.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteEditarCaixaCirurgica.vue?vue&type=style&index=0&id=04783e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04783e2e",
  null
  
)

export default component.exports